import React, { useEffect, useRef } from 'react';

import amplitude from 'amplitude-js';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { PROMO_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FIELDS_SCREEN } from 'apps/auth/constants/Constants';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

import LogoutPopup from '../profile/LogoutPopup';

const AdditionalFieldsInfoScreen = (props) => {
    const {
        notNowButton,
        continueButton,
        promoTellBitMoreAboutYourselfMainText,
        promoTellBitMoreAboutYourselfMainTextGrayTitle,
        promoTellBitMoreAboutYourselfMainTextPurpleTitle,
    } = usePageMessages();
    const popupRef = useRef(null);

    useEffect(() => {
        amplitude.getInstance().logEvent(PROMO_SCREEN_SHOWN);
    }, []);

    return (
        <BaseLayout>
            <InfoPage
                iconName="paysend-logo-globe"
                iconColor="primary"
                topButtonType="button"
                topButtonCaption={notNowButton}
                topButtonOnClick={(e) => {
                    e?.preventDefault();
                    popupRef?.current?.open(<LogoutPopup popupRef={popupRef} />);
                }}
                headerText={
                    <>
                        <span>{promoTellBitMoreAboutYourselfMainTextPurpleTitle} </span>
                        {promoTellBitMoreAboutYourselfMainTextGrayTitle}
                    </>
                }
                secondaryText={MarkdownService.splitByParagraph(promoTellBitMoreAboutYourselfMainText, [], { color: 'secondary' })}
                primaryButtonCaption={continueButton}
                primaryButtonOnClick={() => {
                    props.setScreen(FIELDS_SCREEN);
                }}
            />
            <PopupNew ref={popupRef} />
        </BaseLayout>
    );
};

export default AdditionalFieldsInfoScreen;
